export default {
  // 重置密码页面子路由参数
  resetPasswordRouterParams: ['account', 'detail'],
  preTelList: ['86'],
}
